import { encodeURI } from 'js-base64';
import { numberToMXN } from './formatters';

interface MerchantData {
  callback: string;
  merchantLogo: string;
  merchantName: string;
  amount: number;
  cancellationToken: string;
  merchantId: string;
}

const queryParamValue = new RegExp(/.{1,255}/g);

const getCallbackFragments = (callback: string) => {
  const callbackArray = callback.match(queryParamValue) || [];

  const callbackFragments: Record<string, unknown> = {};

  if (callbackArray?.length > 1) {
    callbackFragments['ext-store-back-link-fragments'] = callbackArray?.length;

    Array.from({ length: callbackArray.length }, (_, i) => i).forEach((i) => {
      if (i === 0) callbackFragments['ext-store-back-link'] = callbackArray[i];
      else callbackFragments[`ext-store-back-link-${i}`] = callbackArray[i];
    });
  }

  return callbackFragments;
};

export default function serializeMerchantData(data: MerchantData) {
  const callbackEncoded = encodeURI(data.callback);

  const callbackFragments = getCallbackFragments(callbackEncoded);

  return {
    'ext-cancellation-token': data.cancellationToken ? encodeURI(data.cancellationToken) : undefined,
    'ext-store-back-link': data.callback ? callbackEncoded : undefined,
    'ext-store-name': data.merchantName ? encodeURI(data.merchantName) : undefined,
    'ext-store-total': data.amount ? encodeURI(numberToMXN(data.amount)) : undefined,
    merchantId: data.merchantId,
    ...callbackFragments,
  };
}
